/* eslint-disable max-len */
import React from 'react'

export default function LogotypeIcon() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.2465 12.5894C29.2465 11.1593 30.4058 10 31.8358 10H37.8777C39.3078 10 40.4671 11.1593 40.4671 12.5894V35.0306C40.4671 36.4607 39.3078 37.62 37.8777 37.62H31.8358C30.4058 37.62 29.2465 36.4607 29.2465 35.0306V12.5894Z"
        fill="#22C55E"
      />
      <path
        d="M12.4155 12.5894C12.4155 11.1593 13.5748 10 15.0049 10H21.0468C22.4768 10 23.6362 11.1593 23.6362 12.5894V35.0306C23.6362 36.4607 22.4768 37.62 21.0468 37.62H15.0049C13.5748 37.62 12.4155 36.4607 12.4155 35.0306V12.5894Z"
        fill="#22C55E"
      />
      <path
        d="M12.4155 28.9888H23.6362V31.7939H12.4155V28.9888Z"
        fill="url(#paint0_linear_1330_159)"
      />
      <path
        d="M29.2465 28.9888H40.4671V31.7939H29.2465V28.9888Z"
        fill="url(#paint1_linear_1330_159)"
      />
      <path
        d="M4 21.4364C4 20.0063 5.1593 18.847 6.58937 18.847H40.467V29.2045H6.58938C5.1593 29.2045 4 28.0452 4 26.6152V21.4364Z"
        fill="#4ADE80"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1330_159"
          x1="18.0258"
          y1="28.9888"
          x2="18.0258"
          y2="31.7939"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#16A34A" />
          <stop offset="1" stopColor="#16A34A" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1330_159"
          x1="34.8568"
          y1="28.9888"
          x2="34.8568"
          y2="31.7939"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#16A34A" />
          <stop offset="1" stopColor="#16A34A" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}
